import { subDays, subMonths } from 'date-fns';
import type { CountyCoverageCardType } from './summary-cards';

/**
 * Returns the start date for a county coverage summary card's date range.
 * End date is passed in (typically "today"); the returned date is the range start.
 * @param {CountyCoverageCardType} card - The summary card type (last24h, last7d, last30d, last6m)
 * @param {Date} endDate - The end date of the range (e.g. today)
 * @return {Date} The start date of the range
 */
export function getStartDate(
  card: CountyCoverageCardType,
  endDate: Date
): Date {
  const cardToStartDate: Record<CountyCoverageCardType, (end: Date) => Date> = {
    last24h: (end) => subDays(end, 1),
    last7d: (end) => subDays(end, 7),
    last30d: (end) => subDays(end, 30),
    last6m: (end) => subMonths(end, 6),
  };
  return cardToStartDate[card](endDate);
}
